import * as jsxRuntime from "/opt/gitlab-runner/builds/pearsontechnology/gpt/bronte/lib/bronte-api-viewer/packages/dev-shell/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment